import * as angular from 'angular';
import '../infoma.jquery';
import { fn } from '@common/utils';
import UISafe = fn.UISafe;
import resolveToError = fn.resolveToError;
import { IDialogService, IMessageIgnore, IKWFSignDoc, IKWFSignOptions, GetMessage, TDefer, $ModalClose, ChoiceType, $ModalOpen, $ModalOpened, $ModalRequestClose } from '@common/services/DialogService';
import { IDMSUILine, DMSUILineType } from '../navdata';
import { ModalSignDocument } from '../infoma.sign';

export { IDialogService, IMessageIgnore };

/** angularjs Dialog Service Implementation */
export class DialogService implements IDialogService {
    static $inject = ['$injector', '$controller', '$q', '$timeout', '$templateRequest'];
    constructor(private $injector: ng.auto.IInjectorService, private $controller: ng.IControllerService,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService, private $templateRequest: ng.ITemplateRequestService) { }

    /** attach Listener to Destroy Event: In Modal Scenario : use Custom Event (in "$destroy" UI might already been torn down, e.g. storing user settings might not work anymore */
    public static OnDestroy($scope: ng.IScope, listener: (event: ng.IAngularEvent, ...args: any[]) => any) {
        var onEvent = $scope["_InfModalScope"] === true ? $ModalClose : "$destroy";
        return $scope.$on(onEvent, listener);
    }

    /** Show an Input Dialog for simple text */
    public ShowInput(options: { title: string; message: string; messageIsHtml?: boolean; inputText?: string; isPassword?: boolean }) {
        var result = this.$q.defer<{ okPressed?: boolean; inputString: string }>();
        var state = { okPressed: null, inputString: options.inputText };
        var modal = this.ShowWindow({
            controller: ["$scope", function ShowInput($scope) {
                $scope.message = !options.messageIsHtml ? options.message : "";
                $scope.state = state;
                $scope.InputClose = (result?: boolean) => {
                    state.okPressed = result;
                    modal.then(m => m.window.close());
                };
            }],
            template: '<p style = "margin-bottom: 20px;" >{{message}}' + (options.messageIsHtml ? options.message : "") +
                '<br/><br/><input type="' + (options.isPassword ? "password" : "text") + '" class="k-textbox" style="width: 350px;" ng-model="state.inputString" navautofocus ng-keyup="($event.which == 13 && InputClose(true)) || ($event.which == 27 && InputClose())"></input></p>' +
                '<div align="center">' +
                '<button class="k-button" style="min-width: 100px; margin-right: 5px;" ng-click="InputClose(true)" ng-keyup="$event.which == 27 && InputClose(null)">OK</button >' +
                '<button class="k-button" style="min-width: 100px;" ng-click="InputClose(false)" ng-keyup="$event.which == 27 && InputClose(null)">Abbrechen</button>' +
                '</div>',
            windowOptions: <kendo.ui.WindowOptions>{
                title: options.title,
                autoFocus: false,
                modal: true,
                maxWidth: Math.max(Math.ceil(window.innerWidth / 2), 200)
            }
        });

        modal.then(r => {
            r.close.then(s => this.$timeout(() => result.resolve(state)));
        }, err => result.reject(err));

        return result.promise;
    }

    /** Show a Message Dialog */
    public ShowDialog(options: { title?: string; message: string; messageIsHtml?: boolean, Ignore?: IMessageIgnore } | string) {
        if (typeof options == "string")
            options = <any>{ message: options };
        options = angular.extend({
            answers: [
                { caption: "Ok", result: undefined, default: true },
            ]
        }, options);
        return this.ShowQuestion<void>(<any>options);
    }

    /** Show Error, supress "Internal" Cancel Error */
    public ShowError(message: any, title?: string) {
        if (fn.error.IsCancel(message))
            return this.$q.when();

        if (!(typeof (message) == "string"))
            message = resolveToError(message, false);

        if (!(typeof (message) == "string")) {
            //tslint:disable-next-line
            alert("Fataler Fehler: " + message);
            return this.$q.when(<void>undefined);
        }
        return this.ShowDialog({ title: title || "Fehler", message: message });
    }

    /** Show a Confirm Dialog */
    public ShowConfirm(options: string | { title?: string; message: string; messageIsHtml?: boolean, Ignore?: IMessageIgnore }) {
        if (typeof options === "string") {
            options = { message: options };
        }
        options = angular.extend({
            answers: [
                { caption: "Ja", result: true },
                { caption: "Nein", result: false, default: true }
            ]
        }, options);
        return this.ShowQuestion<boolean>(<any>options);
    }

    /** Show Confirm with Implicit promise reject when user rejects */
    public WhenConfirm(options: string | { title?: string; message: string; messageIsHtml?: boolean, Ignore?: IMessageIgnore }) {
        return this.ShowConfirm(options).then(a => a || fn.error.ThrowCancel()).then(fn.nullOp);
    }

    /** Show a Dialog with a choice of User Responses */
    public ShowQuestion<T>(options: {
        title?: string;
        message: string;
        Ignore?: IMessageIgnore;
        messageIsHtml?: boolean;
        answers: Array<{ caption: string; result: T; /** Wird initial Selektiert, Antwort bei Abbruch */default?: boolean }>;
        choiceType?: ChoiceType;
    }) {
        var choiceTemplate = '';
        if (options && options.answers && options.answers.length > 0) {
            var selectedResult = (options.answers.filter(a => a.default)[0] || options.answers[0]).result;
        }
        switch (options.choiceType) {
            case ChoiceType.Choice:
                choiceTemplate =
                    "<div align='center'>" +
                    "<div style='display: inline-block; text-align: left;'>" +
                    '<div ng-repeat="answer in answers track by answer.caption">' +
                    '<label ng-click="ChangeChoice(answer.result)">' +
                    '<input name="ChoiceConfirm" type="radio" style="position: relative; top: -1px; margin-right: 4px;" value="{{answer.result}}" ng-checked="answer.autoFocus">{{answer.caption}}' +
                    "</label>" +
                    "</div><br/>" +
                    "</div>" +
                    "</div>" +
                    '<div align="center">' +
                    '<button class="k-button" style="min-width: 100px;" navautofocus="true" ng-click="Close()" ng-keyup="$event.which == 27 && Close()">OK</button>' +
                    '</div>';
                break;

            default:
                choiceTemplate =
                    '<div align="center">' +
                    '<button ng-repeat="answer in answers track by answer.caption" navautofocus="{{answer.autoFocus}}" class="k-button" style="min-width: 100px; margin-right: 5px;" ng-click="ConfirmClose(answer.result)" ng-keyup="$event.which == 27 && Close()">{{answer.caption}}</button >' +
                    '<div>';
                break;
        }
        var me = this;

        if (options.messageIsHtml)
            var messageTemplate = '<p style="margin-bottom: 20px;">' + options.message + '</p>';
        else {
            // transform line breaks to HTML
            var messages = (options.message || "").replace(/\r\n|\n\r|\n|\r/g, "\n").split("\n");
            // Remove trailing empty lines (WTF)
            while (messages.length && !messages[messages.length - 1]) {
                messages.pop();
            }

            var messageTemplate = '<p><span ng-repeat="msg in messages track by $index">{{msg}}<br></span></p>';
        }
        var ignore = options && options.Ignore;
        if (ignore && !ignore.IgnoreMessage)
            ignore.IgnoreMessage = "Diese Meldung zukünftig ignorieren";

        let ignoreTemplate = !ignore ? "" : `<div align="center"><input id="infCheckCnfrm" type="checkbox" ng-model="Ignore.IsIgnored" /><label for='infCheckCnfrm'>{{Ignore.IgnoreMessage}}</label></div><br />`;
        var modal = this.ShowWindow({
            controller: ["$scope", function ShowInput($scope) {
                $scope.messages = messages;
                $scope.message = options.message;
                if (ignore)
                    $scope.Ignore = ignore;
                $scope.answers = options.answers.map(item => { return { caption: item.caption, result: item.result, autoFocus: !!item.default }; });
                $scope.ConfirmClose = (result: T) => {
                    selectedResult = result;
                    modal.then(r => r.window.close());
                };
                $scope.Close = () => modal.then(r => r.window.close());
                $scope.ChangeChoice = (result: any) => selectedResult = result;
            }],
            template: messageTemplate + ignoreTemplate + choiceTemplate,
            windowOptions: <kendo.ui.WindowOptions>{
                autoFocus: false,
                title: options.title || "Bestätigung",
                modal: true,
                maxWidth: Math.max(Math.ceil(window.innerWidth / 2), 200),
            }
        });

        let result = this.$q.defer<T>();
        modal.then(r => r.close.then(s => me.$timeout(() => result.resolve(selectedResult))), err => result.reject(err));
        return result.promise;
    }

    /**  show Modal Dialog */
    public ShowWindow(options: IDialogRoute): PromiseLike<IDialogState> {
        let $injector = this.$injector,
            $templateRequest = this.$templateRequest,
            $timeout = this.$timeout,
            $q = this.$q,

            // Focused element before opening this child window
            lastFocus = document.activeElement;
        //  Get the actual html of the template.
        return getTemplate()
            .then((template) => {
                //  Create a new scope for the modal.
                let modalScope = $injector.get<ng.IRootScopeService>("$rootScope").$new();
                modalScope["_InfModalScope"] = true;

                var windowOptions: kendo.ui.WindowOptions = options.windowOptions || <kendo.ui.WindowOptions>{};
                // Set desired default options  if not explicitly set otherwise
                if (!windowOptions.actions) windowOptions.actions = ["Close"];
                if (!windowOptions.appendTo) {
                    // attach window to root element of ng-app (needed for test scenarios)
                    var root = $injector.get("$rootElement");
                    if (root && root[0] && !(root[0] instanceof Document))
                        windowOptions.appendTo = root; // Change only if needed, "stacked Modals" will not work properly otherwise
                }
                if (windowOptions.resizable == undefined) windowOptions.resizable = false;
                if (windowOptions.animation == undefined) windowOptions.animation = { open: { duration: 0 }, close: { duration: 0 } };
                var forcedClose = false;
                windowOptions.close = e => {
                    if (forcedClose)
                        return;

                    var defer = new Array<() => PromiseLike<any>>();
                    var ev = modalScope.$emit($ModalRequestClose, <TDefer>{ Defer: item => defer.push(item) });
                    if (!ev || !ev.defaultPrevented) {
                        e.preventDefault();
                        UISafe($q.all(defer.map(d => d())).then(() => {
                            forcedClose = true;
                            if (kendoWindow) {
                                kendoWindow.close();
                            }
                            $timeout(() => {
                                modalScope.$emit($ModalClose);
                                closeDeferred.resolve();
                            });
                        }));
                    }
                    else
                        e.preventDefault();
                };
                windowOptions.resize = e => fitSize(e);
                var closeDeferred = $q.defer<void>();
                //  When close is resolved, we'll clean up the scope and element.
                closeDeferred.promise.finally(() => {
                    //  CleanUp
                    modalScope.$destroy();
                    if (kendoWindow) {
                        kendoWindow.destroy();
                    }
                    $(window).off("resize", fitSize);

                    // Restore former focus
                    if (lastFocus) {
                        $(lastFocus).focus();
                    }
                });
                var kendoWindow = <kendo.ui.Window>$("<div />").kendoWindow(windowOptions).data("kendoWindow");
                CreateWindowOverlay(kendoWindow);

                // setup Title Formula generation ....
                if (options.titleFormula) {
                    modalScope.$on("$destroy", <any>modalScope.$watch<string>(options.titleFormula, (newValue) => {
                        if (newValue)
                            kendoWindow.title(newValue);
                    }));
                }

                // Prepare locals w. Possible promises
                var locals = angular.extend({ $scope: modalScope }, {});
                angular.forEach(options.resolve, (value: any, key) => {
                    var resolvedValue = angular.isString(value) ? $injector.get(value) : (fn.isPromise(value) ? value : $injector.invoke(value));
                    locals[key] = fn.isPromise(resolvedValue) ? resolvedValue.then(r => locals[key] = r) : resolvedValue;
                });

                // Fitsize on browser bounds change
                var fitSize = (e?) => {
                    $(kendoWindow && kendoWindow.wrapper).fitToOffsetParent();
                };
                // Watch for browser resize
                $(window).on("resize", fitSize);
                // Watch for async content resize
                kendoWindow.wrapper.find(".k-window-content").onSizeChanged(fitSize);
                // Fitsize on window open
                kendoWindow.bind("open", fitSize);

                return $q.all(locals).then(() => {

                    // Build/Compile Element
                    var modalElementTemplate = angular.element(template);
                    var linkFn = $injector.get<ng.ICompileService>("$compile")(modalElementTemplate);
                    var resolvedModalElement = linkFn(modalScope);
                    var appendTo = kendoWindow.element[0];
                    angular.forEach(resolvedModalElement, item => appendTo.appendChild(item));

                    // Create Controller if Configured
                    if (options.controller) {
                        var modalController = this.$controller(options.controller, locals);

                        if (options.controllerAs)
                            modalScope[options.controllerAs] = modalController;
                    }

                    let defer = new Array<() => PromiseLike<any>>();

                    if (modalScope.$emit($ModalOpen, <TDefer>{ Defer: item => defer.push(item) }).defaultPrevented) {
                        defer["__reject"] = $q.reject("rejected");
                    };

                    $q.all(defer.map(d => d())).then(() => {
                        kendoWindow.open();
                        // Center if no explicit positioning
                        var opt = kendoWindow.options && kendoWindow.options.position;
                        if (!opt || (opt.left == "0" && opt.top == "0")) {
                            kendoWindow.center();
                            // QQQ timeout : Ensure content is rendered (?)
                            $timeout(() => {
                                kendoWindow.center();
                                modalScope.$broadcast($ModalOpened);
                            });
                        } else {
                            modalScope.$broadcast($ModalOpened);
                        }
                    }, err => {
                        closeDeferred.reject(err);
                        throw err;
                    });
                    const result: IDialogState = {
                        controller: modalController,
                        scope: modalScope,
                        window: kendoWindow,
                        close: closeDeferred.promise,
                        closeDialog: () => {
                            kendoWindow.close();
                        }
                    };
                    closeDeferred.promise.then(() => result.closeDialog = fn.noop);
                    return result;
                });
            });

        function getTemplate() {
            if (options && options.template) {
                return $q.when(options.template);
            } else if (options && options.templateUrl) {
                return $templateRequest(options.templateUrl, false);
            } else {
                throw new Error("No template or templateUrl has been specified.");
            }
        }

        /**  Create Overlay "behind" kendowindow to hide heavyweight objects (PDF, ...) */
        function CreateWindowOverlay(kWindow: kendo.ui.Window) {
            if (!kWindow || !kWindow.wrapper)
                return;
            var overlay = $('<iframe tabindex="-1" src="javascript:\'<html></html>\';" ' +
                'frameborder="0" scrolling="no" style="position: absolute;"></iframe>');
            var wrapper = kWindow.wrapper;
            var resizeAction = fn.maxInterval(() => {
                overlay.offset(wrapper.offset());
                overlay.width(wrapper.outerWidth());
                overlay.height(wrapper.outerHeight());
            }, 25);
            kWindow.bind("open", (e) => {
                // no overlay if open operation got cancelled
                var isDefaultPrevented = fn.isFunction(e && e.isDefaultPrevented) && <boolean>e.isDefaultPrevented();
                if (isDefaultPrevented) {
                    return;
                }
                overlay.insertBefore(kWindow.wrapper);
                kWindow.bind("dragend", resizeAction);
                kWindow.bind("resizeEnd", resizeAction);
                wrapper.on("resize", resizeAction);
                wrapper.bind("DOMSubtreeModified", resizeAction);
                resizeAction();
            });
            kWindow.bind("activate", () => {
                // Assign z-index to show over parent window
                var zindex = parseInt(kWindow.wrapper.css("zIndex"));
                if (zindex > 0) {
                    overlay.css("zIndex", zindex);
                }
            });
            kWindow.bind("close", () => {
                overlay.remove();
                kWindow.unbind("dragend", resizeAction);
                kWindow.unbind("resizeEnd", resizeAction);
                wrapper.off("resize", resizeAction);
                wrapper.unbind("DOMSubtreeModified", resizeAction);
            });
        }
    }

    /** User Interaction to Answer UIMessage from Custom NAV Message Handling System */
    public UIAnswerConfirmMessage(item: IDMSUILine): PromiseLike<void> {
        // Preserve Line breaks in message Display
        var rawMessage = GetMessage(item);
        var rawMessages = (rawMessage || "").replace(/\r\n|\n\r|\n|\r/g, "\n").split("\n");
        var strHtmlMessage = rawMessages.map(raw => $("<div>").text(raw).html()).join("<br />");

        switch (item.Type) {
            case DMSUILineType.Confirm:
                return this.ShowConfirm({ title: "Bestätigung", message: strHtmlMessage, messageIsHtml: true }).then(answer => {
                    item.Shown = true;
                    item.Answer = answer ? 1 : 2;
                });

            case DMSUILineType.Message:
                return this.ShowDialog({ message: strHtmlMessage, title: 'Meldung', messageIsHtml: true }).then(() => {
                    item.Shown = true;
                });
            case DMSUILineType.StrMenu:
                var data = GetMessage(item).split(";#"); // 0 : "," separated choices, 1 : Mess
                var strAnswers = data[0].split(",");
                var htmlmessage = $("<div>").text(data[1]).html();
                var defaultAnswer = item.Answer > 0 && item.Answer < strAnswers.length ? item.Answer : 1;
                var answers = strAnswers.map((a, idx) => { return { caption: a, result: idx + 1, default: defaultAnswer == idx + 1 }; });
                return this.ShowQuestion({
                    title: "Auswahl",
                    message: htmlmessage,
                    messageIsHtml: true,
                    choiceType: ChoiceType.Choice,
                    answers: answers
                }).then((strAnswer) => {
                    item.Shown = true;
                    item.Answer = strAnswer;
                });

            default:
                return this.$q.reject("Unknown DMSUILineType:" + item.Type);
        }
    }

    /** Sign Documents */
    public ModalSignDocument<TSignDoc extends IKWFSignDoc>(signOptions: IKWFSignOptions, signDocs: PromiseLike<TSignDoc[]> | any[]): PromiseLike<TSignDoc[]> {
        return ModalSignDocument(this.$injector, signOptions, signDocs);
    }
}

/** 'Route' Object for Dialog Display */
export interface IDialogRoute<T = any>/** extends ng.route.IRoute */ {
    /** we support only string Urls (no Route Params) */
    templateUrl?: string;
    /** we support resolve of Controller; any[] is not documented, will work in base also*/
    controller?: T extends new (...args: any[]) => infer TControllerClass ? TControllerClass : any; // string | Function | any[];
    controllerAs?: string;
    resolve?: { [key: string]: any };
    /** Options for the kendo Window */
    windowOptions?: Omit<kendo.ui.WindowOptions, "close">;
    mobile?: {
            fullScreen?: boolean
    };
    /** Formula Determining the title Calculated from Generated Scope */
    titleFormula?: string;
    template?: string;

    // those Props defined on Route make no sense here
    //redirectTo?: string | { ($routeParams?: angular.route.IRouteParamsService, $locationPath?: string, $locationSearch?: any): string };
    //reloadOnSearch?: boolean;
    //caseInsensitiveMatch?: boolean;
}

/** State Info Returned from DialogService.ShowWindow */
export interface IDialogState {
    controller?: any;
    scope: ng.IScope;
    window: kendo.ui.Window;
    close: PromiseLike<any>;
    closeDialog(): void;
}

/** Custom Typed Angular Event */
export interface TAngularEvent<TArg1> {
    (e: ng.IAngularEvent, arg1: TArg1): void;
}

/** Defer angular event based Continuation */
export type TDeferAngularEvent = TAngularEvent<TDefer>;
